export enum CognitoStatus {
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  CONFIRMED = 'CONFIRMED ',
}
